// @flow
import type { DeliveryMethodType } from 'digicel-kaizen-library';

export type SignUpDeliveryMethodActionType =
  | {|
      type: 'SIGNUP_SET_DELIVERY_METHOD',
      payload: {|
        deliveryMethod: DeliveryMethodType,
      |},
    |}
  | {
      type: 'SIGNUP_RESET_DELIVERY_METHOD',
    }
  | {
      type: 'SIGNUP_SET_DELIVERY_METHODS',
      payload: {
        methods: Object[],
        hasGeolocation: boolean,
      },
    };

export function setDeliveryMethod(deliveryMethod: DeliveryMethodType): SignUpDeliveryMethodActionType {
  return {
    type: 'SIGNUP_SET_DELIVERY_METHOD',
    payload: {
      deliveryMethod,
    },
  };
}

export const setDeliveryMethods = (methods: Object[], hasGeolocation: boolean): SignUpDeliveryMethodActionType => ({
  type: 'SIGNUP_SET_DELIVERY_METHODS',
  payload: { methods, hasGeolocation },
});

export const resetDeliveryMethod = (): SignUpDeliveryMethodActionType => ({
  type: 'SIGNUP_RESET_DELIVERY_METHOD',
});
